<template>
  <fragment>
    <div class="confectionModal">
      <div class="confectionModal-top">
        <img class="confectionModal-image img-responsive ml-0 mr-auto" alt="envelope example" :src="image">
      </div>

      <div class="confectionModal-content">
        <h2 class="confectionModal-title">Ozdobne etui na kartę</h2>
        <section class="confectionModal-descriptions">
          <p>
            Zapakowany prezent wzbudza więcej pozytywnych emocji i wywołuje radość u obdarowywanego.
            <br />
            Etui na kartę Pluxee to dodatek, który podkreśli wyjątkowość prezentowanej karty i nada jej efektu WOW. Zamów i przekonaj się!
          </p>
        </section>
      </div>
    </div>
  </fragment>
</template>

<script>
export default {
  name: 'NDEEtuiCardModal',
  props: {
    image: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
